import { PublicClientApplication } from "@azure/msal-browser";
import api from "@account/api/auth";

export const uMSALLogout = async function (clientId: string = "") {
    if (clientId === "") {
        var item = await api.getIdentityAzureInfo();
        clientId = item.applicationID;
    }

    api.logout().then(() => {
        let msal = new PublicClientApplication({
            auth: {
                clientId: clientId,
                redirectUri: `${window.location.origin}`,
                postLogoutRedirectUri: `${window.location.origin}`,
            },
        });

        msal.logoutRedirect();
    });
};
